import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, ButtonBase, Grid, Paper, Typography, useMediaQuery, useTheme } from '@mui/material';

import { ReactComponent as ArrowRight } from 'assets/images/arrow_right_1.svg';
import { ROUTES } from 'consts';
import { useAppSelector } from 'store/store.hook';
import { selectCurrentUserInfo } from 'store/slices/auth.slice';
// import { useFetchSubscriptionPreviewMutation } from 'store/apis/billing.api';

interface OnboardingReviewProps {
  next?: () => void;
}

export const OnboardingReview = ({ next = () => {} }: OnboardingReviewProps) => {
  const theme = useTheme();
  const down_sm = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();
  const { orgSlug, canCreateBuildings } = useAppSelector(selectCurrentUserInfo);

  return (
    <Grid container spacing={4}>
      {canCreateBuildings && (
        <Grid item xs={12}>
          <Paper
            sx={{
              overflow: 'hidden',
              border: '1px solid transparent',
              '&:hover': {
                border: `1px solid ${theme.palette.primary.light}`,
              },
            }}
          >
            <ButtonBase
              sx={{ width: '100%', display: 'block', textAlign: 'left', cursor: 'pointer' }}
              onClick={() => {
                navigate(ROUTES.BUILDINGS);
                next();
              }}
            >
              <Box sx={{ paddingX: down_sm ? 2 : 4, paddingY: 2.5 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                  <Typography color="primary" sx={{ fontWeight: 600 }}>
                    Add more Buildings
                  </Typography>

                  <Box sx={{ marginLeft: 'auto' }}>
                    <ArrowRight style={{ width: 32, color: theme.palette.primary.main }} />
                  </Box>
                </Box>

                <Box sx={{ paddingRight: down_sm ? 5 : 8 }}>
                  <Typography variant="body2" color="textSecondary">
                    Have more buildings you would like to deploy cleancode to? Go to buildings page to manage and create
                    more buildings.
                  </Typography>
                </Box>
              </Box>
            </ButtonBase>
          </Paper>
        </Grid>
      )}

      <Grid item xs={12}>
        <Paper
          sx={{
            overflow: 'hidden',
            border: '1px solid transparent',
            '&:hover': {
              border: `1px solid ${theme.palette.primary.light}`,
            },
          }}
        >
          <ButtonBase
            sx={{ width: '100%', display: 'block', textAlign: 'left', cursor: 'pointer' }}
            onClick={() => {
              navigate(`/${orgSlug}/${ROUTES.ZONES}/${ROUTES.ZONES_ACTIVE}`);
              next();
            }}
          >
            <Box sx={{ paddingX: down_sm ? 2 : 4, paddingY: 2.5 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                <Typography color="primary" sx={{ fontWeight: 600 }}>
                  Create more Zones
                </Typography>

                <Box sx={{ marginLeft: 'auto' }}>
                  <ArrowRight style={{ width: 32, color: theme.palette.primary.main }} />
                </Box>
              </Box>

              <Box sx={{ paddingRight: down_sm ? 5 : 8 }}>
                <Typography variant="body2" color="textSecondary">
                  Need to make some adjustments? No worries, head over to the Zones page and easily make edits.
                </Typography>
              </Box>
            </Box>
          </ButtonBase>
        </Paper>
      </Grid>
    </Grid>
  );
};
